import { useQuery } from "@tanstack/react-query";
import { PatientPortalEmailControllerApi } from "../../services";
import { getConfigObject, getXtenantId } from "../../utils/utils";

interface Props {
  patientId: string;
  enabled?: boolean;
}

export const usePatientPortalEmailUnreadCount = ({
  patientId,
  enabled,
}: Props) => {
  return useQuery({
    queryKey: ["patient-portal-email-unread-count", patientId],
    refetchOnWindowFocus: false,
    enabled: !!patientId && enabled !== false,
    queryFn: async () =>
      new PatientPortalEmailControllerApi(getConfigObject())
        .getUnreadCount(patientId, getXtenantId())
        .then((res) => res?.data?.data),
  });
};
